import { ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE } from '@atlassian/jira-common-constants/src/spa-routes';

export const legacyProjectReleasesNoteRoute = {
	name: ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE,
	path: '/secure/ReleaseNote.jspa',
	query: ['projectId', 'version'],
};
